export const prefixApi = '/api';
